import GenericErrorPage from './GenericErrorPage.tsx'

export default function ErrorUserNotFound() {
  return (
    <GenericErrorPage
      title="User Not Found"
      description="We can't find an existing user with this email. Please either use a different email or sign up as a new user"
    />
  )
}
